<template>
  <div>
    <input name="filters[price][min]" type="hidden" v-model="priceRange[0]" />
    <input name="filters[price][max]" type="hidden" v-model="priceRange[1]" />
    <div class="range">${{ priceRange[0] }} - ${{ priceRange[1] }}</div>
    <vue-slider
      v-model="priceRange"
      :min="minimum"
      :max="maximum"
      :enable-cross="false"
      :min-range="10"
      :interval="1"
      :tooltip="'none'"
    ></vue-slider>
  </div>
</template>
<script>
export default {
  props: ["min", "max"],
  data: function() {
    return {
      priceRange: [300, 346]
    };
  },
  created() {
    this.priceRange[0] = this.minimum;
    this.priceRange[1] = this.maximum;
  },
  computed: {
    minimum: function() {
      return parseInt(this.min);
    },
    maximum: function() {
      return parseInt(this.max);
    }
  }
};
</script>